module.exports = __webpack_public_path__ + "static/media/layout5-img.52b513e7.svg";